// extracted by mini-css-extract-plugin
export default {"telephonePopup":"phoneInfoPopup__telephonePopup__qm8_g","iconContainer":"phoneInfoPopup__iconContainer__A_QYz","editIcon":"phoneInfoPopup__editIcon__lN8db"};